
import { BuyCrypto } from '@uikit/icons/BuyCrypto';
import { Calendar } from '@uikit/icons/Calendar';
import { Cup } from '@uikit/icons/Cup';
import { MsqToken } from '@uikit/icons/MsqToken';

import {
  getStepsToJoinCampaign,
  JOIN_CAMPAIGN_STEP_TYPE,
} from '@store:web/components/pages/StoryPage/SpecificStory/ui/StepsToJoinCampaign/getStepsToJoinCampaign';

import type { StepsToJoinCampaignStep } from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';

export const partners = [
  {
    name: 'COINTELEGRAPH The future of money',
    image: {
      src: '/launchpad/stories/st/storm-trade-partner-cointelegraph.png',
      width: 402,
      height: 104,
    },
  },
  {
    name: 'Gotbit hedge funds',
    image: {
      src: '/launchpad/stories/st/storm-trade-partner-gotbit-hedge-fund.png',
      width: 222,
      height: 45,
    },
  },
  {
    name: 'TONcoin.Funds',
    image: {
      src: '/launchpad/stories/st/storm-trade-partner-toncoin-fund.png',
      width: 247,
      height: 24,
    },
  },
  {
    name: 'PYTH',
    image: {
      src: '/launchpad/stories/st/storm-trade-partner-pyth.png',
      width: 256,
      height: 90,
    },
  },
  {
    name: 'Tonstarter',
    image: {
      src: '/launchpad/stories/st/storm-trade-partner-tonstarter.png',
      width: 156,
      height: 45,
    },
  },
  {
    name: 'Tonkeeper',
    image: {
      src: '/launchpad/stories/st/storm-trade-partner-tonkeepr.png',
      width: 437,
      height: 91,
    },
  },
];

export const stats = [
  {
    name: 'Prize Pool',
    stat: '5,000,000 $STORM',
    description: '0.5% from Total 1,000,000,000 Supply',
    Icon: Cup,
  },
  {
    name: 'Token Price',
    stat: '$0.012',
    description: 'IDO Price',
    Icon: BuyCrypto,
  },
  {
    name: 'Campaign Duration',
    stat: (
      <>
        May 9<span className="text-base">th</span> - TGE Date
      </>
    ),
    description: 'TGE Estimated start of June 2024',
    Icon: Calendar,
  },
  {
    name: 'Distribution',
    stat: '15% at TGE and then 6-month linear',
    Icon: MsqToken,
  },
];

export const stepsToJoinStormTradeCampaign: StepsToJoinCampaignStep[] = [
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.REGISTER_MAGIC_STORE_ACCOUNT,
    JOIN_CAMPAIGN_STEP_TYPE.ADD_EVM_WALLET,
    JOIN_CAMPAIGN_STEP_TYPE.USERNAME_AND_EMAIL,
    JOIN_CAMPAIGN_STEP_TYPE.LINK_TON_WALLET,
    JOIN_CAMPAIGN_STEP_TYPE.VERIFY_HUMANITY,
    JOIN_CAMPAIGN_STEP_TYPE.VISIT_CAMPAIGN_PAGE,
    JOIN_CAMPAIGN_STEP_TYPE.MONITOR_LEADERBOARD,
  ]),
  {
    id: 'airdrop',
    title: 'Storm Trade will directly airdrop your reward to your Ton Wallet following the TGE',
  },
];

export const kols = [
  {
    id: 'hanzo',
    name: 'Hanzo',
    image: {
      src: '/launchpad/stories/st/storm-trade-kol-hanzo.png',
      width: 279,
      height: 279,
    },
  },
  {
    id: 'daan',
    name: 'Daan Crypto\u00A0Trades', // \u00A0 - non breaking space
    image: {
      src: '/launchpad/stories/st/storm-trade-kol-daan.png',
      width: 279,
      height: 279,
    },
  },
  {
    id: 'ellio',
    name: 'EllioTrades',
    image: {
      src: '/launchpad/stories/st/storm-trade-kol-ellio.png',
      width: 279,
      height: 279,
    },
  },
];
